import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const MultiSlotsIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="49" height="25" viewBox="0 0 49 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_7476_460247)">
      <mask id="path-1-inside-1_7476_460247" fill="white">
        <path d="M0.822266 6H40.1331C41.8934 6 43.3204 7.42703 43.3204 9.18736V21.2285C43.3204 22.9888 41.8934 24.4159 40.1331 24.4159H0.822266V6Z" />
      </mask>
      <rect x="1.82227" y="7" width="40.5" height="16.4159" stroke="#D1D1D1" strokeWidth="2" />
    </g>
    <path
      d="M0.822266 6H43.3204H0.822266ZM43.3204 24.4159H0.822266H43.3204ZM-1.17773 24.4159V6H2.82227V24.4159H-1.17773ZM43.3204 6V24.4159V6Z"
      fill="#959693"
      mask="url(#path-1-inside-1_7476_460247)"
    />
    <g clipPath="url(#clip1_7476_460247)">
      <path
        d="M5.82227 0H45.1331C46.8934 0 48.3204 1.42703 48.3204 3.18736V15.2285C48.3204 16.9888 46.8934 18.4159 45.1331 18.4159H5.82227V0Z"
        fill="#D1D1D1"
      />
      <rect x="5.82227" width="2" height="18.4159" fill="#959693" />
    </g>
    <defs>
      <clipPath id="clip0_7476_460247">
        <path
          d="M0.822266 6H40.1331C41.8934 6 43.3204 7.42703 43.3204 9.18736V21.2285C43.3204 22.9888 41.8934 24.4159 40.1331 24.4159H0.822266V6Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_7476_460247">
        <path
          d="M5.82227 0H45.1331C46.8934 0 48.3204 1.42703 48.3204 3.18736V15.2285C48.3204 16.9888 46.8934 18.4159 45.1331 18.4159H5.82227V0Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)

export const MultiSlotsSelectedIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="48" height="25" viewBox="0 0 48 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_7476_460260)">
      <mask id="path-1-inside-1_7476_460260" fill="white">
        <path d="M0.322266 6H39.6331C41.3934 6 42.8204 7.42703 42.8204 9.18736V21.2285C42.8204 22.9888 41.3934 24.4159 39.6331 24.4159H0.322266V6Z" />
      </mask>
      <rect x="1.32227" y="7" width="40.5" height="16.4159" stroke="white" strokeWidth="2" />
    </g>
    <path
      d="M0.322266 6H42.8204H0.322266ZM42.8204 24.4159H0.322266H42.8204ZM-1.67773 24.4159V6H2.32227V24.4159H-1.67773ZM42.8204 6V24.4159V6Z"
      fill="#6450F7"
      mask="url(#path-1-inside-1_7476_460260)"
    />
    <g clipPath="url(#clip1_7476_460260)">
      <path
        d="M5.32227 0H44.6331C46.3934 0 47.8204 1.42703 47.8204 3.18736V15.2285C47.8204 16.9888 46.3934 18.4159 44.6331 18.4159H5.32227V0Z"
        fill="white"
      />
      <rect x="5.32227" width="2" height="18.4159" fill="#6450F7" />
    </g>
    <defs>
      <clipPath id="clip0_7476_460260">
        <path
          d="M0.322266 6H39.6331C41.3934 6 42.8204 7.42703 42.8204 9.18736V21.2285C42.8204 22.9888 41.3934 24.4159 39.6331 24.4159H0.322266V6Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_7476_460260">
        <path
          d="M5.32227 0H44.6331C46.3934 0 47.8204 1.42703 47.8204 3.18736V15.2285C47.8204 16.9888 46.3934 18.4159 44.6331 18.4159H5.32227V0Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)
